import { render, staticRenderFns } from "./SocialWallImageRatioEditor.vue?vue&type=template&id=0fa6c5bc"
import script from "./SocialWallImageRatioEditor.vue?vue&type=script&lang=js"
export * from "./SocialWallImageRatioEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports